export function getProfileTimeMs(profile, ...fields) {
  for (const field of fields) {
    const value = profile?.[field];
    if (!value) continue;
    if (typeof value.toMillis === "function") return value.toMillis();
    if (typeof value.seconds === "number") {
      return value.seconds * 1000 + (value.nanoseconds || 0) / 1e6;
    }
    const parsed = new Date(value).getTime();
    if (!Number.isNaN(parsed)) return parsed;
  }
  return 0;
}

export function compareProfilesByRecency(a, b) {
  const aTime = getProfileTimeMs(a, "createdAt", "updatedAt");
  const bTime = getProfileTimeMs(b, "createdAt", "updatedAt");
  return bTime - aTime;
}

export function compareProfilesByOldest(a, b) {
  return -compareProfilesByRecency(a, b);
}

export function compareProfilesBySortOrder(a, b, sortOrder = "newest") {
  return sortOrder === "oldest" ? compareProfilesByOldest(a, b) : compareProfilesByRecency(a, b);
}
